import Count                                      from "../../../../domain/fundamentals/count/Count";
import ReservationCancelStatusRepository
                                                  from "../../../../domain/reservation/cancel/ReservationCancelStatusRepository";
import ReservationCancelStatusDataSource
                                                  from "../../../../infrastructure/datasource/reservation/cancel/ReservationCancelStatusDataSource";
import { setReservationCancelRequestCountAction } from "../../../../infrastructure/redux/reservation/cancel";

class GetCountRequestedCancelStatus {
  constructor(
    private readonly dispatch,
    private readonly repository: ReservationCancelStatusRepository = new ReservationCancelStatusDataSource(),
  ) {
  }

  public execute(): void {
    try {
      this.repository.countRequestedBy().then(value => this.dispatch(setReservationCancelRequestCountAction(value)));
    } catch (e) {
      this.dispatch(setReservationCancelRequestCountAction(new Count()));
    }
  }
}

export default GetCountRequestedCancelStatus;
